const MODIFIER_KEYS = new Set(["Shift", "Control", "Alt", "Meta"]);

let wasKeyboard = false;

if (typeof document !== "undefined") {
	document.addEventListener(
		"keydown",
		(event) => {
			if (!MODIFIER_KEYS.has(event.key)) wasKeyboard = true;
		},
		true,
	);
	document.addEventListener("pointerdown", () => (wasKeyboard = false), true);
}

/** Whether the user's last input was a key press rather than a pointer press. */
export const lastInputWasKeyboard = () => wasKeyboard;
